var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 95,
    rx: 12,
    fill: "url(#paint0_radial_3370_7773)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.625 35.375L48.9583 47.7708",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.775 47.1662C40.1579 48.5537 37.2664 48.3157 34.375 47.1707C35.105 56.566 39.4852 60.1796 45.3255 61.625C45.3255 61.625 49.7256 58.5135 50.3598 51.1358C50.4285 50.3368 50.4629 49.9373 50.2968 49.4871C50.1305 49.0369 49.8045 48.7141 49.1521 48.0683C48.0794 47.0062 47.543 46.4752 46.9063 46.3422C46.2698 46.2094 45.4382 46.5283 43.775 47.1662Z",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5625 54.9843C36.5625 54.9843 40.2083 55.6875 43.8542 52.875",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3958 41.5729C42.3958 42.5797 41.5797 43.3958 40.5729 43.3958C39.5661 43.3958 38.75 42.5797 38.75 41.5729C38.75 40.5661 39.5661 39.75 40.5729 39.75C41.5797 39.75 42.3958 40.5661 42.3958 41.5729Z",
    stroke: "white",
    strokeWidth: 2.1875
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0417 36.8333V36.9791",
    stroke: "white",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3370_7773",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.1733 65.9267) rotate(-90) scale(65.9267 99.4785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D9D67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217494,
    stopColor: "#1E8157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510916,
    stopColor: "#1F6546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726911,
    stopColor: "#1F573E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204533"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.09ab449be29421e57d3a620955e4f825.svg";
export { ForwardRef as ReactComponent };